import { IAuditLogsReportResponse } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-audit-logs.container';
import { IFlatBirSalesSummary } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-bir-sales-summary.container';
import { IChargeSlip } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-charge-slip.container';
import { ISalesByGroupResponse } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sales-by-group.container';
import { ISalesByInvoiceData } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sales-by-invoice.container';
import { ISalesByItemTypeInterface } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sales-by-item-type.container';
import { ISalesByRevenueResponse } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sales-by-revenue.container';
import { IFlatTransaction } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sc-pwd-detailed.container';
import { ISalesReport } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sc-pwd-summarized.container';
import { ITransactionJournalData } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-transaction-journal.container';
import { IFlatVoidedData } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-voided-items.container';
import { api } from '@services/api';
import { handleError } from '../../utils/api-error-handling';
import { IBaseApiRes } from '@interfaces/generic.interface';
import {
  // IEJournal,
  IEJournalResponse,
} from '@modules/point-of-sale/interface/orders/pos-orders.interface';
import { IDiscountReport } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-sc-discount.container';
import { ICollectionBySettlementReport } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-collection-by-settlement';
import { ICollectionSummaryReport } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-collection-summary';
import { IPOSAllItemListResponse } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-all-item-list';
import { IKPISalesByHour } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-kpi-sales-by-hour';
import { IShiftReport } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-collection-by-shift';
import { ISalesByItemMTDReportResponse } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-kpi-sales-by-item-mtd';
import { IKPIDailyStatistics } from '@modules/point-of-sale/containers/bo-containers/reports/pos-bo-kpi-daily-statistics';

export const posReportsApi = api
  .enhanceEndpoints({ addTagTypes: ['posReports', 'AuditLogs'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllItemListReport: builder.query({
        query: (params: { stationID: string }) => {
          return `reports/pos/item-lists/${params.stationID}`;
        },
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: IPOSAllItemListResponse) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getBirSalesSummaryReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/bir-summary?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IFlatBirSalesSummary }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getChargeSlipReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/charge-slips?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IChargeSlip }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),

      getCollectionBySettlementReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/collections/settlement?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: ICollectionBySettlementReport;
        }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getCollectionByShiftReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/collections/shift?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IShiftReport[] }) => {
          return response?.data || response?.data?.[0];
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getCollectionSummaryReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/collections/summary?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: ICollectionSummaryReport;
        }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getKPICoversByHourReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/kpi/covers-by-hour?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: {
            hours: { hour: { pax: number; order: number; caption: string } }[];
          };
        }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getKPISalesByHourReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/kpi/sales-by-hour?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IKPISalesByHour }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getKPIDailyStatisticsReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/kpi/daily-statistics?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: IKPIDailyStatistics[];
        }) => {
          return response?.data?.[0];
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getKPISalesByItemMTDReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/kpi/sales-by-item-mtd?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: ISalesByItemMTDReportResponse;
        }) => {
          return response?.data?.[0];
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getOsReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) =>
          `reports/pos/order-slips?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`,
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: any) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
      }),
      getSalesByRevenueReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/sales/revenues?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: ISalesByRevenueResponse;
        }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getSalesByGroupReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/sales/groups?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: ISalesByGroupResponse;
        }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getSalesByInvoiceReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/sales/invoice?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: ISalesByInvoiceData }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getSalesByItemTypeReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) =>
          `reports/pos/sales/item-types?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`,
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: ISalesByItemTypeInterface) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getScPwdDetailedReport: builder.query({
        query: (params: {
          discountType: string;
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/sc-pwd?filter[discountType]=${params.discountType}&filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IFlatTransaction }) => {
          return response?.data[0];
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getScPwdSummarizedReport: builder.query({
        query: (params: {
          discountType: string;
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/sc-pwd/summarized?filter[discountType]=${params.discountType}&filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: ISalesReport[] }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getDiscountReport: builder.query({
        query: (params: {
          discountType: string;
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/discount-reports?filter[discountType]=${params.discountType}&filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IDiscountReport[] }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getTransactionJournalReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/transaction-journal?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: {
          data: ITransactionJournalData;
        }) => {
          return response?.data[0];
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getVoidedItemsReport: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          station: string;
        }) => {
          return `reports/pos/voided-items?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`;
        },
        providesTags: ['posReports'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: { data: IFlatVoidedData }) => {
          return response?.data;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getBOAuditLogsReport: builder.query({
        query: (params: { dateStart: string; dateEnd: string }) =>
          `logs?filter[module]=BO&filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`,
        providesTags: ['AuditLogs'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: IAuditLogsReportResponse) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getXReading: builder.query({
        query: (params: { shiftID: string; printerRefID: string }) =>
          `reports/pos/x-reading/${params.shiftID}?printerRefID=${params.printerRefID}`,
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: (response: {
          data: {
            printData: {
              printer: string;
              printerIPAddress: string;
              payload: [];
            }[];
          };
        }) => response.data,
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getYReading: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          printerRefID: string;
        }) =>
          `reports/pos/y-reading?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}&printerRefID=${params.printerRefID}`,
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: (response: {
          data: {
            results: [
              {
                responseCode: 200;
                responseMessage: 'Success';
              },
            ];
          };
        }) => response.data,
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getZReading: builder.query({
        query: (params: {
          dateStart: string;
          dateEnd: string;
          printerRefID: string;
        }) =>
          `reports/pos/z-reading?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}&printerRefID=${params.printerRefID}`,
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: (response: {
          data: {
            printData: {};
          };
        }) => response.data,
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
      getEJournal: builder.query({
        query: (params: { dateStart: string; dateEnd: string }) =>
          `reports/pos/e-journal?filter[dateStart]=${params.dateStart}&filter[dateEnd]=${params.dateEnd}`,
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: (response: IBaseApiRes<IEJournalResponse>) =>
          response.data,
        forceRefetch() {
          return true;
        },
        keepUnusedDataFor: 0.0001,
      }),
    }),
  });

export const {
  useLazyGetAllItemListReportQuery,
  useLazyGetBirSalesSummaryReportQuery,
  useLazyGetChargeSlipReportQuery,
  useLazyGetCollectionBySettlementReportQuery,
  useLazyGetCollectionByShiftReportQuery,
  useLazyGetCollectionSummaryReportQuery,
  useLazyGetKPICoversByHourReportQuery,
  useLazyGetKPISalesByHourReportQuery,
  useLazyGetKPIDailyStatisticsReportQuery,
  useLazyGetKPISalesByItemMTDReportQuery,
  useLazyGetOsReportQuery,
  useLazyGetSalesByGroupReportQuery,
  useLazyGetSalesByRevenueReportQuery,
  useLazyGetSalesByInvoiceReportQuery,
  useLazyGetSalesByItemTypeReportQuery,
  useLazyGetScPwdDetailedReportQuery,
  useLazyGetScPwdSummarizedReportQuery,
  useLazyGetDiscountReportQuery,
  useLazyGetTransactionJournalReportQuery,
  useLazyGetVoidedItemsReportQuery,
  useLazyGetBOAuditLogsReportQuery,
  useLazyGetXReadingQuery,
  useLazyGetYReadingQuery,
  useLazyGetZReadingQuery,
  useLazyGetEJournalQuery,
} = posReportsApi;
